import React, { } from "react";
import { OverPaymentAmount } from "./over-payment-amount";
import { PartialPaymentAmount } from "./partial-payment-amount";

export interface IPaymentAmountModalProps {
  fullBalanceAmount: number;
  allowPartialPayment: boolean | null;
  allowOverPayment: boolean | null;
  currentPaymentAmount?: number;
  updateCallBack: (amount: number) => void;
}

export const PaymentAmountModal = (props: IPaymentAmountModalProps) => {
  const {
    allowPartialPayment,
    allowOverPayment,
    fullBalanceAmount,
    currentPaymentAmount,
    updateCallBack,
  } = props;

  if (fullBalanceAmount <= 0 && allowOverPayment) {
    return (
      <OverPaymentAmount
        currentPaymentAmount={currentPaymentAmount}
        updateCallBack={updateCallBack}
      ></OverPaymentAmount>
    );
  }

  return (
    <PartialPaymentAmount
      fullBalanceAmount={fullBalanceAmount}
      allowPartialPayment={allowPartialPayment}
      currentPaymentAmount={currentPaymentAmount}
      updateCallBack={updateCallBack}
    ></PartialPaymentAmount>
  );
};
